import { makeAutoObservable } from "mobx";
import { openApi } from "../../../helpers/request";
import { notification } from "antd";
import i from "../../../translations/i";

class LoadManagementController {

  item: any = {
    kitchen: 0,
    delivery: 0,
    stop_delivery: false,
    stop_orders: false
  }

  warehousesInfo: any[] = []

  constructor() {
    makeAutoObservable(this)
  }

  getWarehousesInfo() {
    openApi('get', `/load_management/wh_info`)
      .then(result => {
        console.log(result)
        this.warehousesInfo = result.data
      })
      .catch((error) => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error')
        })
      })
  }

  setBool(warehouse_id: number, info: any) {
    const data = new FormData()
    data.append('warehouse_id', `${warehouse_id}`)
    data.append('kitchen', info.kitchen)
    data.append('delivery', info.delivery)
    data.append('stop_delivery', `${+ info.stop_delivery}`)
    data.append('stop_orders', `${+ info.stop_orders}`)

    openApi('post', `/load_management`, data)
      .then(result => {
        this.getWarehousesInfo()
      })
      .catch((error) => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error')
        })
      })
  }

  get(warehouse_id: number | null = null) {
    let path = `/load_management`
    if(warehouse_id) path += `?warehouse_id=${warehouse_id}`

    openApi('get', path)
      .then(result => {
        console.log(result)
        this.item = result.data
      })
      .catch((error) => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error')
        })
      })
  }

  save(warehouse_id: number | null = null) {
    const data = new FormData()
    data.append('warehouse_id', `${warehouse_id}`)
    data.append('kitchen', this.item.kitchen)
    data.append('delivery',  this.item.delivery)
    data.append('stop_delivery', `${+ this.item.stop_delivery}`)
    data.append('stop_orders', `${+ this.item.stop_orders}`)

    openApi('post', `/load_management`, data)
      .then(result => {
        this.get(warehouse_id)
      })
      .catch((error) => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error')
        })
      })
  }

}

export default new LoadManagementController()